module.exports = __webpack_public_path__ + "static/media/comsicon.dc80620f.png";